module.exports = __webpack_public_path__ + "img/refund.e6d82124.svg";